import { Box } from "@mui/material";
import NewPrescription from "./NewPrescription";

const Record = ({ appointment, onClose }) => {
  return (
    <Box m="1px">
      <NewPrescription
        appointment={appointment}
        onClose={onClose}
        showPatientHeading={false}
      />
    </Box>
  );
};

export default Record;
